/*!*
 **                 _     _                         
 ** __      ___ __ | |   (_)_ __   __ _ _   _  __ _ 
 ** \ \ /\ / / '_ \| |   | | '_ \ / _` | | | |/ _` |
 **  \ V  V /| |_) | |___| | | | | (_| | |_| | (_| |
 **   \_/\_/ | .__/|_____|_|_| |_|\__, |\__,_|\__,_|
 **          |_|                  |___/             
 **
 **        -- wpLingua | WordPress plugin --
 **   Translate and make your website multilingual
 **
 **     https://github.com/julien-jacob/wplingua
 **      https://wordpress.org/plugins/wplingua/
 **              https://wplingua.com/
 **
 **/

jQuery(document).ready(function ($) {

    /**
     * Code for first loading
     */

    if ($("#wplng-notice-first-loading-loading").length) {
        $("#toplevel_page_wplingua-settings .wp-submenu-wrap").hide();
    }

    if ($("#wplng-notice-first-loading-loading").length) {

        let percent = 1;
        let percentMax = 0;

        // store interval id so we can stop it
        let percentInterval = setInterval(function () {

            if (percent >= 99) {
                // stop at 99% until the actual loads finish
                percent = 99;
                clearInterval(percentInterval);
                return;
            } else if (percent >= percentMax) {
                percent = percentMax;
                return;
            }

            percent++;

            $("#wplng-notice-first-loading-loading-percent").text(percent + " %");

        }, 800);

        let loadUrl = $("#wplng-notice-first-loading-loading").attr("data-wplng-url-first-load");

        if (loadUrl) {
            const times = 3;
            const delayMs = 1000;

            (async function () {
                for (let i = 0; i < times; i++) {
                    // wait for the request to finish (success or error) before starting the next one
                    await new Promise((resolve) => {

                        percent = percentMax;
                        percentMax += 33;

                        $.ajax({
                            url: loadUrl,
                            method: "GET",
                            success: function (response) {
                                resolve(response);
                            },
                            error: function () {
                                // continue despite the error to perform all 3 loads
                                resolve();
                            }
                        });
                    });

                    // small delay between loads
                    if (i < times - 1) {
                        await new Promise(r => setTimeout(r, delayMs));
                    }
                }

                // ensure progress shows 100% and stop interval
                clearInterval(percentInterval);
                percent = 100;
                $("#wplng-notice-first-loading-loading-percent").text("100 %");

                // once the 3 loads are complete, show the UI
                $("#wplng-notice-first-loading-loading").hide();
                $("#wplng-notice-first-loading-loaded").slideDown();
                wplngLaunchConfetti();
                $("#wplng-option-settings-form").slideDown();
                $("#toplevel_page_wplingua-settings .wp-submenu-wrap").slideDown();
            })();
        }

    }


    /**
     * Code for input
     */

    let wplngWebsiteLanguage = $("#wplng_website_language").val();
    let wplngTargetLanguages = JSON.parse($("#wplng_target_languages").val());


    function wplngTargetLanguagesIncludes(languageId) {

        let returned = false;

        wplngTargetLanguages.forEach(targetLanguage => {
            if (targetLanguage.id == languageId) {
                returned = true;
            }
        });

        return returned;
    }


    function wplngLanguagesIsPrivate(languageId) {
        let returned = false;
        wplngTargetLanguages.forEach(targetLanguage => {
            if (targetLanguage.id == languageId && targetLanguage.private == true) {
                returned = true;
                return;
            }
        });
        return returned;
    }


    function wplngGetOptionsWebsiteLanguageHTML() {

        let languagesOptionsHTML = "";

        wplngAllLanguages.forEach((language) => {

            let selected = "";
            let disabled = "";

            if (
                wplngWebsiteLanguage !== undefined &&
                wplngWebsiteLanguage === language.id
            ) {
                selected = " selected";
            }

            if (wplngTargetLanguagesIncludes(language.id)) {
                disabled = " disabled";
            }

            languagesOptionsHTML +=
                '<option value="' +
                language.id +
                '"' +
                selected +
                disabled +
                ">" +
                language.name +
                "</option>";
        });

        return languagesOptionsHTML;
    }


    function wplngGetOptionsTargetLanguagesHTML() {

        let languagesOptionsHTML = "";
        let hideFieldset = true;

        wplngAllLanguages.forEach((language) => {
            let disabled = "";
            if (
                (
                    wplngWebsiteLanguage !== undefined
                    && wplngWebsiteLanguage === language.id
                )
                || wplngTargetLanguagesIncludes(language.id)
            ) {
                disabled = " disabled";
            } else {
                hideFieldset = false;
            }


            languagesOptionsHTML +=
                '<option value="' +
                language.id +
                '"' +
                disabled +
                ">" +
                language.name +
                "</option>";
        });

        if (hideFieldset) {
            $("#fieldset-add-target-language").hide();
        } else {
            $("#fieldset-add-target-language").show();
        }

        if (
            $("#fieldset-add-target-language").is(":visible")
            && $("#wplng-target-languages-container").is(":visible")
        ) {
            $("#wplng-languages-target-separator").show();
        } else {
            $("#wplng-languages-target-separator").hide();
        }

        return languagesOptionsHTML;
    }


    function wplngGetWebsiteLanguageNameHTML() {

        let html = "";

        wplngAllLanguages.forEach((language) => {

            if (language.id == wplngWebsiteLanguage) {

                html += '<img src="' + language.flag + '" id="wplng-website-flag"></img> ';
                html += language.name;

            }
        });

        return html;

    }


    function wplngGetWebsiteLanguageFlagsHTML() {

        let flagsRadiosHTML = "";

        wplngAllLanguages.forEach((language) => {

            if (language.id == wplngWebsiteLanguage) {

                let textCustomRadio = $("#wplng-flags-radio-original-website-custom").text();
                let websiteFlagUrl = $("#wplng_website_flag").val();
                let flagFirstChecked = false;
                let flagCustomChecked = " checked";

                if (websiteFlagUrl == "") {
                    flagFirstChecked = true;
                }

                language.flags.forEach(flag => {

                    let checked = "";

                    if (websiteFlagUrl == flag.flag) {
                        checked = " checked";
                        flagCustomChecked = "";
                    }

                    if (flagFirstChecked) {
                        checked = " checked";
                        flagCustomChecked = "";
                        flagFirstChecked = false;
                        $("#wplng_website_flag").val(flag.flag);
                    }

                    flagsRadiosHTML +=
                        '<span class="wplng-flags-radio">' +
                        '<input type="radio" ' +
                        'name="wplng-website-flag" ' +
                        'value="' + flag.flag + '" ' +
                        'id="wplng-flag-' + flag.id + '"' + checked + '>' +
                        '<label for="wplng-flag-' + flag.id + '">' +
                        flag.name + ' (<img src="' + flag.flag + '">)' +
                        '</label></span>';
                });

                flagsRadiosHTML +=
                    '<span class="wplng-flags-radio">' +
                    '<input type="radio" name="wplng-website-flag" id="wplng-website-flag-custom" value="custom"' + flagCustomChecked + '>' +
                    '<label for="wplng-website-flag-custom">' + textCustomRadio + '</label>' +
                    '</span>';

                if ("" != flagCustomChecked) {
                    $("#wplng-website-flag-container").show();
                } else {
                    $("#wplng-website-flag-container").hide();
                }
            }
        });

        return flagsRadiosHTML;
    }


    function wplngGetTargetLanguagesListHTML() {

        let html = "";
        let htmlTemplate = $("#wplng-target-language-template").html();

        // Process languages in the order they appear in wplngTargetLanguages
        wplngTargetLanguages.forEach((targetLang, index) => {

            // Find the full language data from wplngAllLanguages
            let language = wplngAllLanguages.find(lang => lang.id === targetLang.id);
            if (!language) return;

            let htmlElement = "";
            let textCustomRadio = $("#wplng-flags-radio-original-website-custom").text();
            let flagsRadiosHTML = "";
            let flagFirstChecked = false;
            let flagCustomChecked = " checked";
            let targetFlagUrl = targetLang.flag || "";

            if (targetFlagUrl == "") {
                flagFirstChecked = true;
            }

            language.flags.forEach(flag => {

                let checked = "";

                if (targetFlagUrl == flag.flag) {
                    checked = " checked";
                    flagCustomChecked = "";
                }

                if (flagFirstChecked) {
                    checked = " checked";
                    flagCustomChecked = "";
                    flagFirstChecked = false;
                    value = flag.flag;
                }

                flagsRadiosHTML +=
                    '<span class="wplng-subflags-radio">' +
                    '<input type="radio" ' +
                    'name="wplng-target-subflag-' + language.id + '" ' +
                    'value="' + flag.flag + '" ' +
                    'wplng-target-lang="' + language.id + '" ' +
                    'id="wplng-subflag-' + language.id + '-' + flag.id + '"' + checked + '>' +
                    '<label for="wplng-subflag-' + language.id + '-' + flag.id + '">' +
                    flag.name + ' (<img src="' + flag.flag + '">)' +
                    '</label></span>';
            });

            flagsRadiosHTML +=
                '<span class="wplng-flags-radio">' +
                '<input type="radio" name="wplng-target-subflag-' + language.id +
                '" id="wplng-target-flag-custom-' + language.id + '" value="custom"' +
                ' wplng-target-lang="' + language.id + '" ' +
                flagCustomChecked + '>' +
                '<label for="wplng-target-flag-custom-' +
                language.id + '">' + textCustomRadio + '</label>' +
                '</span>';

            let isPrivate = wplngLanguagesIsPrivate(language.id);
            let inputPrivate = '';

            inputPrivate += '<input ';
            inputPrivate += ' type="checkbox"';
            inputPrivate += ' id="wplng-language-private-' + language.id + '"';
            inputPrivate += ' name="wplng-language-private"';
            inputPrivate += ' value="private"';
            inputPrivate += ' wplng-target-lang="' + language.id + '"';

            if (isPrivate) {
                inputPrivate += ' checked';
            }

            inputPrivate += '/>';

            htmlElement = htmlTemplate;
            htmlElement = htmlElement.replaceAll("[PRIVATE_INPUT]", inputPrivate);
            htmlElement = htmlElement.replaceAll("[NAME]", language.name);
            htmlElement = htmlElement.replaceAll("[LANG]", language.id);
            let htmlFlag =
                '<img src="' + targetFlagUrl + '" class="wplng-target-flag">';
            htmlElement = htmlElement.replaceAll("[FLAG]", htmlFlag);
            htmlElement = htmlElement.replaceAll("[FLAGS_OPTIONS]", flagsRadiosHTML);

            if (isPrivate) {
                htmlElement = htmlElement.replaceAll(
                    'class="wplng-target-language"',
                    'class="wplng-target-language wplng-is-private"'
                );
            }

            // Add ordering attributes and visibility classes for arrows
            let orderClass = '';
            let arrowsVisibility = '';

            if (wplngTargetLanguages.length > 1) {
                if (index === 0) {
                    // First item: only down arrow
                    arrowsVisibility = 'wplng-hide-up-arrow';
                } else if (index === wplngTargetLanguages.length - 1) {
                    // Last item: only up arrow
                    arrowsVisibility = 'wplng-hide-down-arrow';
                }
                // Middle items: both arrows visible (no class needed)
            } else {
                // Single item: hide both arrows
                arrowsVisibility = 'wplng-hide-arrows';
            }

            htmlElement = htmlElement.replaceAll(
                'class="wplng-target-language"',
                'class="wplng-target-language ' + arrowsVisibility + '"'
            );

            htmlElement = htmlElement.replaceAll(
                'class="wplng-target-language wplng-is-private"',
                'class="wplng-target-language wplng-is-private ' + arrowsVisibility + '"'
            );

            let htmlInput = '<input type="url" class="wplng-target-subflag" wplng-target-lang="' + language.id + '" value="' + targetLang.flag + '" />';
            htmlElement = htmlElement.replaceAll("[INPUT]", htmlInput);

            if (flagCustomChecked == "") {
                htmlElement = htmlElement.replaceAll(
                    'class="wplng-subflag-target-custom"',
                    'class="wplng-subflag-target-custom hide"'
                );
            } else {
                htmlElement = htmlElement.replaceAll(
                    'class="wplng-subflag-target-custom"',
                    'class="wplng-subflag-target-custom show"'
                );
            }

            html += htmlElement;
        });

        if ("" == html) {
            $("#wplng-target-languages-container").hide();
        } else {
            $("#wplng-target-languages-container").show();
        }

        if (
            $("#fieldset-add-target-language").is(":visible")
            && $("#wplng-target-languages-container").is(":visible")
        ) {
            $("#wplng-languages-target-separator").show();
        } else {
            $("#wplng-languages-target-separator").hide();
        }

        return html;
    }


    // Option Page : Click on "Add" button for new language target
    $("#wplng-target-lang-add").on("click", function () {

        if (
            wplngTargetLanguages.length != 0
            && !confirm($("#wplng_add_new_target_language_message").text())
        ) {
            return;
        }

        let newTargetId = $("#wplng_add_new_target_language").val();
        let newTargetFlag = "";

        wplngAllLanguages.forEach((language) => {
            if (language.id == newTargetId) {
                newTargetFlag = language.flag;
            }
        });

        let newTarget = {
            "id": newTargetId,
            "flag": newTargetFlag
        };

        if (!wplngTargetLanguagesIncludes(newTargetId)) {
            wplngTargetLanguages.push(newTarget);
        }

        wplngUpdateOptionPage();
    });


    $("#wplng-target-languages-list").on(
        "click",
        ".wplng-target-lang-remove",
        (event) => {

            let newTargetLanguages = [];
            let removed = $(event.target).attr("wplng-target-lang");

            wplngTargetLanguages.forEach((language) => {
                if (language.id != removed) {
                    newTargetLanguages.push(language);
                }
            });

            wplngTargetLanguages = newTargetLanguages;

            wplngUpdateOptionPage();
        }
    );

    // Handle move up functionality
    $("#wplng-target-languages-list").on(
        "click",
        ".wplng-target-lang-move-up",
        (event) => {
            event.preventDefault();

            let languageId = $(event.target).closest('a').attr("wplng-target-lang");
            let currentIndex = wplngTargetLanguages.findIndex(lang => lang.id === languageId);

            if (currentIndex > 0) {
                // Swap with previous item
                let temp = wplngTargetLanguages[currentIndex];
                wplngTargetLanguages[currentIndex] = wplngTargetLanguages[currentIndex - 1];
                wplngTargetLanguages[currentIndex - 1] = temp;

                wplngUpdateOptionPage();
            }
        }
    );

    // Handle move down functionality
    $("#wplng-target-languages-list").on(
        "click",
        ".wplng-target-lang-move-down",
        (event) => {
            event.preventDefault();

            let languageId = $(event.target).closest('a').attr("wplng-target-lang");
            let currentIndex = wplngTargetLanguages.findIndex(lang => lang.id === languageId);

            if (currentIndex < wplngTargetLanguages.length - 1) {
                // Swap with next item
                let temp = wplngTargetLanguages[currentIndex];
                wplngTargetLanguages[currentIndex] = wplngTargetLanguages[currentIndex + 1];
                wplngTargetLanguages[currentIndex + 1] = temp;

                wplngUpdateOptionPage();
            }
        }
    );


    $("#wplng_website_language").on("change", function () {
        wplngWebsiteLanguage = $("#wplng_website_language").val();
        $("#wplng_website_flag").val("");
        $("#wplng_add_new_target_language").html(wplngGetOptionsTargetLanguagesHTML());
        $("#wplng-flags-radio-original-website").html(wplngGetWebsiteLanguageFlagsHTML());

        $("#wplng-website-language").html(wplngGetWebsiteLanguageNameHTML());
    });


    $('#wplng-flags-radio-original-website').on("click", "input[type=radio][name=wplng-website-flag]", function () {
        if ($("#wplng-website-flag-custom").is(':checked')) {
            $("#wplng-website-flag-container").slideDown("fast");
        } else {
            $("#wplng-website-flag-container").slideUp("fast");
            $("#wplng_website_flag").val($(this).val());
        }
    });


    $("#wplng-website-lang-update-flag").on("click", function () {
        $("#wplng-flag-website-container").slideToggle();
    });


    $("#wplng-target-languages-list").on("click", ".wplng-target-lang-update-flag", function () {
        let languageId = $(this).attr("wplng-target-lang");
        let selector = "#wplng-target-languages-list .wplng-flag-target-container[wplng-target-lang=" + languageId + "]";

        $(selector).slideToggle();
    });


    $('#wplng-target-languages-list').on("click", "input[type=radio]", function () {

        let selectedFlagId = $(this).attr("wplng-target-lang");
        let selectedFlagVal = $(this).val();
        let selectorSubflagContainer = ".wplng-subflag-target-custom[wplng-target-lang=" + selectedFlagId + "]";

        if (selectedFlagVal == "custom") {
            $(selectorSubflagContainer).slideDown("fast");
        } else {
            $(selectorSubflagContainer).slideUp("fast");
            $(".wplng-target-subflag[wplng-target-lang=" + selectedFlagId + "]").val(selectedFlagVal);

            let newTargetLanguages = [];
            wplngTargetLanguages.forEach(language => {
                if (language.id == selectedFlagId) {
                    newTargetLanguages.push({
                        "id": language.id,
                        "flag": selectedFlagVal
                    });
                } else {
                    newTargetLanguages.push(language);
                }
            });

            wplngTargetLanguages = newTargetLanguages;
            $("#wplng_target_languages").val(JSON.stringify(newTargetLanguages));
        }
    });


    $('#wplng-target-languages-list').on("click", "input[type=checkbox]", function () {

        let languageId = $(this).attr("wplng-target-lang");
        let isPrivate = $(this).is(":checked");

        if (isPrivate) {
            $(this).parents(".wplng-target-language").addClass("wplng-is-private");
        } else {
            $(this).parents(".wplng-target-language").removeClass("wplng-is-private");
        }

        console.log($(this).parents(".wplng-target-language"));

        let newTargetLanguages = [];
        wplngTargetLanguages.forEach(language => {
            if (language.id == languageId) {
                newTargetLanguages.push({
                    "id": language.id,
                    "flag": language.flag,
                    "private": isPrivate
                });
            } else {
                newTargetLanguages.push(language);
            }
        });

        wplngTargetLanguages = newTargetLanguages;
        $("#wplng_target_languages").val(JSON.stringify(newTargetLanguages));
    });


    $("#wplng-target-languages-list").on("input", ".wplng-target-subflag", function () {

        let selectedFlagId = $(this).attr("wplng-target-lang");
        let selectedFlagVal = $(this).val();
        let newTargetLanguages = [];

        wplngTargetLanguages.forEach(language => {
            if (language.id == selectedFlagId) {
                newTargetLanguages.push({
                    "id": language.id,
                    "flag": selectedFlagVal
                });
            } else {
                newTargetLanguages.push(language);
            }
        });

        wplngTargetLanguages = newTargetLanguages;
        $("#wplng_target_languages").val(JSON.stringify(newTargetLanguages));
    });


    function wplngUpdateOptionPage() {
        $("#wplng_website_language").html(wplngGetOptionsWebsiteLanguageHTML());
        $("#wplng_add_new_target_language").html(wplngGetOptionsTargetLanguagesHTML());
        $("#wplng-flags-radio-original-website").html(wplngGetWebsiteLanguageFlagsHTML());
        $("#wplng-target-languages-list").html(wplngGetTargetLanguagesListHTML());
        $("#wplng_target_languages").val(JSON.stringify(wplngTargetLanguages));
    }

    wplngUpdateOptionPage();

    /**
     * Option for feature "Browser language redirection"
     */

    $("#wplng_browser_language_redirect_checkbox").on("change", function () {
        if ($(this).is(":checked")) {
            $("input[name=wplng_browser_language_redirect][value=js_only]").prop("checked", true);
        } else {
            $("input[name=wplng_browser_language_redirect][value=disable]").prop("checked", true);
        }
    });

    function wplngUpdateBrowserLanguageRedirect() {

        let selectedMethod = $("input[name=wplng_browser_language_redirect]:checked").val();

        if (selectedMethod === "php_js" || selectedMethod === "js_only") {
            $("#wplng_browser_language_redirect_checkbox").prop("checked", true);
        } else {
            $("#wplng_browser_language_redirect_checkbox").prop("checked", false);
        }
    }

    $("input[name=wplng_browser_language_redirect]").on("change", function () {
        wplngUpdateBrowserLanguageRedirect();
    });

    wplngUpdateBrowserLanguageRedirect();

    /**
     * Show / Hide API key
     */

    $("#wplng-api-key-show").click(function () {
        $("#wplng-api-key-show").hide();
        $("#wplng-api-key-hide").show();
        $("#wplng-api-key-fake").hide();
        $("#wplng_api_key").show();
    });


    $("#wplng-api-key-hide").click(function () {
        $("#wplng-api-key-hide").hide();
        $("#wplng-api-key-show").show();
        $("#wplng-api-key-fake").show();
        $("#wplng_api_key").hide();
    });


    /**
     * Confetti effect on first loading success
     */
    function wplngLaunchConfetti() {

        const canvas = document.createElement( 'canvas' );
        canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
        document.body.appendChild( canvas );

        const ctx    = canvas.getContext( '2d' );
        canvas.width  = window.innerWidth;
        canvas.height = window.innerHeight;

        const colors    = [ '#e8a0a0', '#e8b4c8', '#c4a8d4', '#a8b8e0', '#a8ccec', '#a8d8e0', '#a8d4b8', '#e8e0a0', '#e8cca0', '#d8d8d8' ];
        const particles = [];

        function spawnBurst( originX, directionX ) {
            for ( let i = 0; i < 80; i++ ) {
                const angle = ( Math.random() * 40 - 20 ) * Math.PI / 180;
                const speed = Math.random() * 16 + 10;
                particles.push( {
                    x:        originX,
                    y:        canvas.height,
                    vx:       Math.cos( angle ) * speed * directionX,
                    vy:       -Math.abs( Math.sin( angle ) * speed ) - Math.random() * 12 - 8,
                    w:        Math.random() * 10 + 5,
                    h:        Math.random() * 5 + 3,
                    color:    colors[ Math.floor( Math.random() * colors.length ) ],
                    rot:      Math.random() * Math.PI * 2,
                    rotSpeed: ( Math.random() - 0.5 ) * 0.15,
                    gravity:  0.3,
                    alpha:    1
                } );
            }
        }

        spawnBurst( canvas.width * 0.1,  1 );  // left cannon
        spawnBurst( canvas.width * 0.9, -1 );  // right cannon

        let frame;
        const startTime = performance.now();
        const duration  = 5000;

        function animate() {
            const elapsed = performance.now() - startTime;
            ctx.clearRect( 0, 0, canvas.width, canvas.height );

            let active = false;

            particles.forEach( function ( p ) {
                p.vy += p.gravity;
                p.x  += p.vx;
                p.y  += p.vy;
                p.rot += p.rotSpeed;

                if ( elapsed > duration - 1000 ) {
                    p.alpha = Math.max( 0, p.alpha - 0.02 );
                }

                if ( p.y < canvas.height + 20 && p.alpha > 0 ) {
                    active = true;
                }

                ctx.save();
                ctx.globalAlpha = p.alpha;
                ctx.translate( p.x, p.y );
                ctx.rotate( p.rot );
                ctx.fillStyle = p.color;
                ctx.fillRect( -p.w / 2, -p.h / 2, p.w, p.h );
                ctx.restore();
            } );

            if ( active && elapsed < duration ) {
                frame = requestAnimationFrame( animate );
            } else {
                cancelAnimationFrame( frame );
                canvas.remove();
            }
        }

        frame = requestAnimationFrame( animate );
    }

}); // End jQuery loaded event
